import { reduce, has, isEmpty, concat, merge } from 'lodash';
function buildOptions() {
  let {
    options = [],
    disableParent = true,
    level = 0
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return reduce(options, (acc, opt) => {
    if (has(opt, 'children') && !isEmpty(opt.children)) {
      const newOpt = merge(opt, {
        hasChildren: true,
        level,
        disabled: disableParent
      });
      return concat(acc, newOpt, buildOptions({
        options: opt.children,
        disableParent,
        level: level + 1
      }));
    }
    return concat(acc, merge(opt, {
      hasChildren: false,
      level
    }));
  }, []);
}
export default buildOptions;
//# sourceMappingURL=buildOptions.js.map